import { useState, useEffect } from "react";

export function useVisible(elementRef, initValue = false) {
  const [isVisible, setIsVisible] = useState(initValue);
  useEffect(() => {
    function intersectionHandler(entries) {
      let isIntersecting = false;
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          isIntersecting = true;
        }
      });
      setIsVisible(isIntersecting);
    }

    if (elementRef.current && typeof IntersectionObserver !== "undefined") {
      const observer = new IntersectionObserver(intersectionHandler);
      observer.observe(elementRef.current);
      return () => {
        observer.disconnect();
      };
    }

    return () => null;
  }, [elementRef.current]);

  return isVisible;
}

export default useVisible;
